package com.xtream.webApp.presentation.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.navigation3.runtime.NavEntry
import androidx.navigation3.runtime.entryProvider
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.LocalSnackbarHostState
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.loading.DataLoadingScreen
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.composeapp.presentation.ui.player.VodVideoPlayer
import com.xtream.composeapp.presentation.ui.tvchannels.CategorySelectionScreen
import com.xtream.composeapp.presentation.ui.tvchannels.ManageCategoriesScreen
import com.xtream.composeapp.presentation.ui.tvchannels.TvChannelsManager
import com.xtream.composeapp.viewmodel.SeriesViewModel
import com.xtream.composeapp.viewmodel.UserViewModel
import com.xtream.composeapp.viewmodel.VodStreamsViewModel
import com.xtream.core_model.dto.MovieSubtitle
import com.xtream.data_kmp.WatchedSeriesStreams
import com.xtream.data_kmp.WatchedVodStreams
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.VodStream
import com.xtream.data_kmp.util.extension.getFileExtension
import com.xtream.ui.tv.presentation.account.ComposeAccountTvScreen
import com.xtream.ui.tv.presentation.movies.MoviesGridTvScreen
import com.xtream.ui.tv.presentation.movies.TvMovieInfoComposeScreen
import com.xtream.ui.tv.presentation.navbar.SideNavBarScreen
import com.xtream.ui.tv.presentation.series.TvShowGridTvScreen
import com.xtream.ui.tv.presentation.series.TvShowTvInfoComposeScreen
import com.xtream.ui.tv.presentation.tvchannels.LiveTvGridTvScreen
import com.xtream.ui.tv.presentation.tvchannels.NewTvChannelsPlayerScreen
import kotlinx.coroutines.launch
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun navEntryProvider(    skipAccountRefresh: Boolean=false,
): (Screen) -> NavEntry<Screen> {

    val scope= rememberCoroutineScope()
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner

    val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner = viewModelStoreOwner?: error("no viewModelStoreOwner provided")
    )
    fun onNavigateClicked(screen: Screen): (() -> Unit)? {
        return rootNavViewModel.backStack.indexOf(screen)
            .takeIf { it > 0 }
            ?.let { { rootNavViewModel.pop() } }
    }

    return entryProvider {
        entry<Screen.Loading>{
            /* ATestFocusRestorationScreen(){
                 scope.launch {
                     rootNavViewModel.navigate( Screen.NavBar)
                 }
             }*/
            DataLoadingScreen(
                skipUserRefresh = it.skipUserRefresh,
                forceRefreshData = it.forceRefreshData,
                navKey = it)
            /*LoadingScreen(
                  skipUserRefresh = skipAccountRefresh,
    forceRefreshData = it.forceRefreshData,
                  navKey = it)*/
        }

        entry<Screen.NavBar> {

                     SideNavBarScreen( )


        }
        entry<Screen.Search> {

            /* SearchScreen(
                 initialPage = it.initialPage,
                 onNavigationIconClick = {
                     scope.launch {
                         rootNavViewModel.backStack.removeLastOrNull()
                     }
                 }
             )*/
        }
        entry<Screen.MoviesGrid> {

                    MoviesGridTvScreen(id = it.categoryId, title = it.title, navKey = it)

        }
        entry<Screen.SeriesGrid> {
            val arg = it

                    TvShowGridTvScreen(id =arg.categoryId, title =  arg.title, navKey = it)

        }
        entry<Screen.LiveTvGrid> {
            val arg = it


                    LiveTvGridTvScreen(id =arg.categoryId, title = arg.title, navKey = it)

        }

        entry<Screen.AccountInfo> {

                    ComposeAccountTvScreen()



        }
        entry<Screen.LiveStreamPlayer> {arg->


                    NewTvChannelsPlayerScreen(arg.id,
                        categoryId = arg.categoryId,
                        title = arg.title,
                        navKey = arg,
                        layoutWidth =with(LocalDensity.current) { LocalWindowInfo.current.containerSize.width.toDp() }
                    )

                    /*LiveTvPlayer(
                        arg.id,
                        categoryId = arg.categoryId,
                        title = arg.title,
                        onNavigationIconClick = {
                            scope.launch {
                                rootNavViewModel.backStack.removeLastOrNull()
                            }
                        },
                        navKey = it,
                        )*/

        }
        entry<Screen.VideoPlayer> {
            val arg = it
            val vodStreamsViewModel: VodStreamsViewModel =
                koinViewModel( key="vodStream_${arg::class.simpleName}${arg.hashCode()}")
            VodVideoPlayer(
                arg.id,
                categoryId = arg.categoryId,
                title = arg.title,
                navKey = it,
                backdropUrl = arg.backdropPath,
                infos = arg.infos,
                url = arg.url,
                progressUpdater = {
                    vodStreamsViewModel.getWatched(arg.id  ?: -1)?.progress?:0
                },
                onPlaybackLoadingChange = { pos, duration ->
                    val watched = WatchedVodStreams(
                        arg.id  ?: -1,
                        pos,
                        duration,
                        arg.backdropPath
                    )
                    vodStreamsViewModel.insertWatched(watched)
                },
                onNavigationIconClick = {
                    scope.launch {
                        rootNavViewModel.backStack.removeLastOrNull()
                    }
                },
                subtitles = arg.subtitles,
                onEnded = {
                    scope.launch {
                        vodStreamsViewModel.removeWatched(arg.id)
                    }
                    rootNavViewModel.backStack.remove(it)
                }
            )


        }
        entry<Screen.MovieDetail> {
            val arg = it



            AdaptiveMovieDetailScreen(
                arg.id,
                navKey = it,
                onMainButtonClick = { url, title, backdropPath, infos, progress, subtitles ->
                    rootNavViewModel.navigate(
                        Screen.VideoPlayer(
                            arg.id,
                            categoryId = arg.id,
                            title = title,
                            backdropPath = backdropPath,
                            infos = infos,
                            url = url,
                            subtitles = subtitles,
                            progress =  progress
                        )
                    )
                    //activity.goToVideoPlayerFragment( url, title, backdropPath, arg.id)
                },
                onRelatedItemClick = { item ->
                    scope.launch {
                        rootNavViewModel.navigate(
                            Screen.MovieDetail(
                                item?.streamId ?: 0
                            )
                        )
                    }
                },
                onNavigationIconClick = {
                    scope.launch {
                        rootNavViewModel.backStack.removeLastOrNull()
                    }
                }

            )
        }

        entry<Screen.TvShowVideoPlayer> {
            val arg = it
            val noId=-1
            val scope = rememberCoroutineScope()
            val seriesStreamsViewModel: SeriesViewModel =  koinViewModel( key="seriesStream_${arg::class.simpleName}${arg.hashCode()}")
            VodVideoPlayer(
                arg.id,
                categoryId = arg.categoryId,
                title = arg.title,
                navKey = it,
                backdropUrl = arg.backdropPath,
                infos = arg.infos,
                url = arg.url,
                progressUpdater = {
                    // scope.launch(Dispatchers.Default) {
                    seriesStreamsViewModel.getWatchedStream(arg.id?:noId)?.progress?:0
                    //  }
                },
                onPlaybackLoadingChange = { pos, duration ->

                    val watched = WatchedSeriesStreams(
                        arg.id ?: -1,
                        episodeId = arg.categoryId ?: noId,
                        pos,
                        videoExtension = arg.url?.getFileExtension(),
                        duration,
                        arg.backdropPath
                    )
                    seriesStreamsViewModel.insertWatched(watched)
                },
                onNavigationIconClick = {
                    scope.launch {
                        rootNavViewModel.backStack.removeLastOrNull()
                    }
                },
                subtitles = arg.subtitles,
                onEnded = {
                    scope.launch {
                        seriesStreamsViewModel.removeWatched(arg.id)
                    }
                    rootNavViewModel.backStack.remove(it)
                }
            )


        }
        entry<Screen.TvShowDetail> {
            val arg = it
          /*  TvShowInfoComposeScreen(
                arg.id,
                navKey = it,
                onNavigationIconClick = {
                    scope.launch {
                        rootNavViewModel.backStack.removeLastOrNull()
                    }
                },

                )*/
            AdaptiveTvShowDetailScreen(
                arg.id,
                onNavigationIconClick = {
                    scope.launch {
                        rootNavViewModel.backStack.remove(arg)
                    }
                },
                onMainButtonClick = { url, title, backdropPath,infos, progress, episodes, tvShowId ->
                    rootNavViewModel.navigate(
                        Screen.TvShowVideoPlayer(
                            streamId =  tvShowId,
                            categoryId =arg.tvShowId,
                            title = title,
                            backdropPath = backdropPath,
                            infos = infos,
                            url = url,
                            progress =  progress
                        )
                    )
                },
                onRelatedItemClick = { item ->
                    scope.launch {
                        rootNavViewModel.navigate(
                            Screen.TvShowDetail(item?.streamId)
                        )
                    }
                },
                navKey = it
            )
        }
        entry<Screen.Trailer> {
            val trailerUrl = it.url
            val snackbarHostState = LocalSnackbarHostState.current


            error("yt player not implemented")
            /*activity.openYoutubeTrailer( trailerUrl?:"", onError = {err->
                scope.launch( Dispatchers.Main) {
                    snackbarHostState.currentSnackbarData?.dismiss()

                    snackbarHostState.showSnackbar(
                        message = err.message.toString(),

                        )
                }
            })*/
            rootNavViewModel.backStack.remove(it)
            /* MyYoutubePlayer (navKey = it, arg.url, onEnded = {navKey->
                 rootNavViewModel.backStack.remove(navKey)
             })*/

        }

        entry<Screen.ChoseTvCategory> {

            CategorySelectionScreen(
                onNavigationIconClick = onNavigateClicked(it)

            )


        }
        entry<Screen.ManageTvChannels> { it ->
            TvChannelsManager(
                category =  it.liveCategory,
                onNavigationIconClick = onNavigateClicked(it)


            )



        }
        entry<Screen.ManageCategories> {
            ManageCategoriesScreen(type = it.type,
                onNavigationIconClick = onNavigateClicked(it)

            )



        }

    }
}



@Composable
fun AdaptiveMovieDetailScreen(
    id: Int?,
    onNavigationIconClick: () -> Unit={},
    onMainButtonClick: (url:String?, title:String?, backdropPath: String?,     infos: List<String>?, progress: Long, subtitles: List<MovieSubtitle.Subtitle?>? ) -> Unit = { _, _, _, _, _, _->},
    navKey:  Screen.MovieDetail,
    userInfViewModel: UserViewModel =  koinViewModel(),
    onRelatedItemClick: (VodStream?) -> Unit = {}
){


            TvMovieInfoComposeScreen(
                id = id,
                onNavigationIconClick = onNavigationIconClick,
                onMainButtonClick = onMainButtonClick,
                navKey = navKey,
                userInfViewModel = userInfViewModel,
                onRelatedItemClick = onRelatedItemClick
            )


}


@Composable
fun AdaptiveTvShowDetailScreen(
    id: Int?,
    onNavigationIconClick: () -> Unit={},
    onMainButtonClick: (url: String?, title: String?, backdropPath: String?, infos: List<String>?, progress: Long, episodes:List<  VodStream>, episodeId:Int) -> Unit = { _, _, _, _, _, _, _-> },
    navKey:  Screen.TvShowDetail,

    userInfViewModel:  UserViewModel =  koinViewModel(),
    onRelatedItemClick: (SeriesStream?) -> Unit = {}
){


            TvShowTvInfoComposeScreen(
                id = id,
                onNavigationIconClick = onNavigationIconClick,
                onMainButtonClick = onMainButtonClick,
                navKey = navKey,
                userInfViewModel = userInfViewModel,
                onRelatedItemClick = onRelatedItemClick
            )


}